export class ClientsCountersModel {
  constructor(public nbrOfParents: number,
              public nbrOfChildren: number) {}
}
